<template>
  <div class="quiz detail-card collapsible-card">
    <div class="banner" @click="toggle(content)" :style="{
      'border-bottom': opened ? '1px solid #E4E7ED' : 'none'
    }">
      <div class="icon">
        <img src="@/assets/lessons/lesson/lesson-quiz-white.svg" />
      </div>
      <p class="align-left title regular"><span class="caps">Quizz&nbsp;</span>-&nbsp;Take our quiz to test your knowledge</p>
      <img class="arrow" :class="{'opened' : opened }" src="@/assets/lessons/lesson/lesson-arrow-right.svg" />
    </div>
    <div class="content" ref="content" data-collapsed="true" v-if="!showResult"> 
      <div class="padded"> 
        <p class="body align-left">Let’s make sure you understood all the key concepts of this first step.</p>
        <p class="body align-left">
          <strong>Answer</strong> and <strong>submit each question at a time</strong>. There is only <strong>1 correct answer per question</strong>. You can take this test as many times as needed.
        </p>

        <p class="body align-left color-blue-translation"><i>Assurons-nous que vous avez bien compris tous les concepts clés de ce use case.</i></p>
        <p class="body align-left color-blue-translation">
          <i><strong>Répondez</strong> et <strong>soumettez chaque question à la fois</strong>. <strong>Une seule réponse correcte par question.</strong> Vous pouvez faire ce test autant de fois que nécessaire.</i>
        </p>

        <div class="questions">
          <div class="question align-left">
            <span class="number">{{currentQuestion + 1}}/{{current.questionCount}}.</span>&nbsp;
            <span v-html="questions[currentQuestion].question"></span>
          </div>
          <div class="answer" v-for="(answer, index) in questions[currentQuestion].options" :key="index"
            :class="{
              'wrong': submitted && currentAnswer && !currentAnswer.correct && currentAnswer === answer,
              'valid': submitted && currentAnswer && currentAnswer.correct && currentAnswer === answer
            }">

            <label :for="`radio-${index}`">
              <input 
              type="radio"
              :id="`radio-${index}`"
              :value="answer"
              v-model="currentAnswer"
              >
              <span class="checkmark">
                <span class="pin"></span>
              </span>
              <div class="answer-text"><span v-html="answer.value"></span></div>  
            </label>
            <div class="icon">
              <span class="icon-valid" v-if="submitted && currentAnswer && currentAnswer.correct && currentAnswer === answer"><img src="@/assets/lessons/lesson/valid.svg" /></span>
              <span class="icon-wrong" v-if="submitted && currentAnswer && !currentAnswer.correct && currentAnswer === answer"><img src="@/assets/lessons/lesson/error.svg" /></span>
            </div>

          </div>
           <div class="question-result">
            <span class="question-correct" v-if="submitted && currentAnswer && currentAnswer.correct">Great, that’s correct!</span>
            <span class="question-incorrect" v-if="submitted && currentAnswer && !currentAnswer.correct">Sorry, this is incorrect!</span>
          </div>
          <button class="submit caps" :class="{'disabled': currentAnswer === null}" @click="submit"><span v-if="currentQuestion < 9">Submit</span><span v-else>See my score</span></button>
        </div>

      </div>
    </div>
    <div class="result content" v-else-if="!loading && showResult" ref="content" data-collapsed="true">
      <div class="wheel">
          <ResultCircle :strokeColor="strokeColor" :questionCount="current.questionCount" :score="score" :progress="score / current.questionCount * 100" />
          <a @click="resetQuiz()">Retake the quiz</a>
      </div>
      <div class="legend">
        <div class="low">
          <div class="score">
            <span class="between">BETWEEN<br></span>
            01 - {{getQuizRange(0, current.questionCount)}}
          </div>
          <div class="description">
            <span>You haven’t grasped all the key concepts yet! Have another look at the tutorials and take this test again.</span>
          </div>
        </div>
        <div class="medium">
          <div class="score" v-if="current.questionCount > 5">
            <span class="between">BETWEEN<br></span>
            {{getQuizRange(1, current.questionCount)}} - {{getQuizRange(2, current.questionCount)}}
          </div>

          <div class="score" v-else>
            {{getQuizRange(1, current.questionCount)}}
          </div>

          <div class="description">
            <span>Almost there! Have another look at the tutorials then come back again for a perfect score!</span>
          </div>
        </div>
        <div class="high">
          <div class="score">
            <span class="between">BETWEEN<br></span>
            {{getQuizRange(3, current.questionCount)}} - {{current.questionCount.toString().padStart(2, "0")}}
          </div>
          <div class="description">
            <span>Outstanding! You now know all the ins and outs of this module!</span>
          </div>
        </div>

        <a @click="$router.push({name: 'home'})">Or go back to my modules</a>
      </div>
    </div>
    <div v-else-if="loading">
      Sending your result..
    </div>
    <div v-else>
      {{error}}
    </div>
  </div>
</template>

<script>
  import {SEND_RESULT} from '@/store/api'
  import { mapGetters } from 'vuex'
  import collapsible from "@/mixins/collapsible"
  import ResultCircle from "./quiz/ResultCircle"
  export default {
    name: 'Quiz',
    mixins: [collapsible],
    data () {
      return {
        opened: false,
        showResult: false,
        loading: false,
        error: '',
        submitted: false,
        currentQuestion: 0,
        currentAnswer: null,
        correctAnswer: null,
        strokeColor: '',
        score: 0,
      }
    },
    components: {
      ResultCircle
    },
    props: {
      questions: {
        type: Array
      }
    },
    computed: {
      content () { return this.$refs.content },
      ...mapGetters({
        current: 'modules/current'
      })
    },
    methods: {
      toggle (element) {
        if (this.opened) {
          this.collapseSection(element)
        } else {
          this.$emit('expanded')
          this.expandSection(element)
          element.setAttribute('data-collapsed', 'false')
        }
        this.opened = !this.opened
      },
      submit () {
        if (!this.submitted) {
          this.submitted = true
          this.correctAnswer = JSON.parse(JSON.stringify(this.currentAnswer))
          if (!this.correctAnswer.correct) {
            this.correctAnswer = JSON.parse(JSON.stringify(this.questions[this.currentQuestion].options.filter(a => {
              return a.correct
            })[0]))
          }
          this.score = this.currentAnswer.correct ? this.score + 1 : this.score
          window.setTimeout(() => {
            if (this.currentQuestion < this.questions.length - 1) {
              this.submitted = false
              this.currentAnswer = null
              this.currentQuestion++
            } else {
              this.setScore()
            }
          }, 1500)
        }
      },
      setScore () {
        this.loading = true
        this.$apollo.mutate({
          mutation: SEND_RESULT,
          variables: {
            input: {
              idModule: this.current.id,
              score: this.score 
            }
          },
          update: () => {
            this.loading = false
            if (this.score / this.current.questionCount <= 0.4) {
              this.strokeColor = '#FF9552'
            } else if (this.score / this.current.questionCount >= 0.7) {
              this.strokeColor = '#0BB864'
            } else {
              this.strokeColor = '#FFE452'
            }
            this.$store.commit('user/set_score', { idModule: this.current.id, score: this.score })
            
            this.showResult = true
          }
        })
        .catch(() => {
          this.error = 'Error something happened'
          this.loading = false
          this.showResult = false
        })
      },
      resetQuiz () {
        this.currentQuestion = 0
        this.score = 0
        this.currentAnswer = null
        this.correctAnswer = null
        this.submitted = false
        this.showResult = false
        this.showValid = false
      },
      getQuizRange(index, quizLength) {
        let range = [];

        range.push(Math.round(quizLength*0.4) < 10 ? '0' + Math.round(quizLength*0.4) : '' + Math.round(quizLength*0.4))
        range.push(Math.round(quizLength*0.4) + 1 < 10 ? '0' + (Math.round(quizLength*0.4) + 1)  : '' + (Math.round(quizLength*0.4) + 1) )
        range.push(Math.round(quizLength*0.6) < 10 ? '0' + Math.round(quizLength*0.6)  :  '' + Math.round(quizLength*0.6) )
        range.push(Math.round(quizLength*0.6) + 1 < 10 ? '0' +  (Math.round(quizLength*0.6) + 1 ): '' + (Math.round(quizLength*0.6) + 1) )

        return range[index]
      }
    },
    watch: {
      shouldCollapse (newVal) {
        if (newVal) {
          this.collapseSection(this.content)
          this.opened = false
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "@/styles";
  .quiz {
    .questions {
      position: relative;
    }
    .question {
      background-color: #F5F7FA;
      color: $primary;
      font-weight: 500;
      font-size: 16px;
      padding: 10px 15px;
      box-sizing: border-box;
      margin-bottom: 8px;
    }
    .answer {
      position: relative;
      min-height: 30px;
      padding-left: 16px;
      padding-right: 20px;
      padding-top: 5px;
      padding-bottom: 5px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      transition: all 0.3s ease;
      margin-bottom: 10px;
      background-color: transparent;

      &.wrong {
        background-color: #F7C2CC;
      }
      &.valid {
        background-color: #C1EDD8;
      }
      label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        text-align: left;
        min-height: 30px;
        width: 100%;
        padding-left: 20px;
        .answer-text {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: calc(100% - 30px);
        }
        input {
          position: absolute;
          opacity: 0;
        }
        .checkmark {
          position: absolute;
          left: 0;
          width: 14px;
          height: 14px;
          top: 50%;
          transform: translateY(-50%);
          border: 2px solid #3E3E3E;
          border-radius: 50%;
          box-sizing: border-box;
          margin: 0 auto;
          .pin {
            position: absolute;
            top: 2px;
            left: 2px;
            opacity: 0;
            width: 6px;
            height: 6px;
            background-color: $primary;
            border-radius: 50%;
            transition: all 0.2s ease-out;
          }
        }
        input:checked ~ .checkmark {
          border-color: $primary;
          .pin {
            opacity: 1;
          }
        }

      }
      .icon {
        position: absolute;
        right: 10px;
        font-size: 20px;
        top: 50%;
        transform: translateY(-50%);
        .icon-valid {
          color: green;
        }
        .icon-error {
          color: red;
        }
      }
      @media (max-width: 414px) {
        padding-left: 5px;

        label {
          font-size: 14px;
          padding-left: 10px;
        }
      }
    }
    .question-result {
      position: absolute;
      bottom: 20px;
      left: 30px;
      .question-correct {
        color: #C1EDD8;
      }
      .question-incorrect {
        color: #F7C2CC;
      }

      @media (max-width: 570px) {
        bottom: 70px;
      }

    }
    .submit {
      background-color: $primary;
      color: white;
      cursor: pointer;
      height: 40px;
      min-width: 125px;
      border-radius: 4px;
      &.disabled {
        pointer-events: none;
        opacity: 0.4;
      }
      @media (max-width: 570px) {
        margin-top: 20px;
      }
      @media (max-width: 414px) {
        margin-top: 40px;
      }
    }
  }
  .result {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .wheel, .legend {
      display: flex;
      flex-direction: column;
      min-height: 300px;
      justify-content: flex-start;
      align-items: flex-start;
      @media (max-width: 679px) {
        align-items: center;
      }
      padding: 28px;
      a {
        color: $primary;
        text-transform: uppercase;
        font-size: 14px;
        margin-top: 40px;
        line-height: 40px;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .wheel {
      position: relative;
      align-items: center;
      flex: 2;
      a {
        width: 100%;
        max-width: 220px;
        height: 40px;
        border: 1px solid $primary;
        border-radius: 4px;

      }
    }
    .legend {
      flex: 3;
      .low,.medium,.high {
        display: flex;
        flex-direction: row;
        width: 100%;
        max-width: 346px;
        min-width: 346px;
        // margin-left: 10px;
        margin-bottom: 10px;
        height: 50px;
        border: 1px solid white;
        border-radius: 2px;
        color: $text;
        padding-left: 30px;
        padding-right: 5px;
        box-sizing: border-box;
        .score {
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          .between {
            font-size: 10px;
            font-weight: 400;
          }
        }
        .description {
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: left;
          margin-left: 20px;
          font-size: 12px;
        }
      }
      .low {
        background-color: #FCC4A1;
        border-color: #FF9552;
      }
      .medium {
        border-color: #FFE452;
        background-color: #FAEDA8;
        .score {
          min-width: 45px;
        }
      }
      .high {
        border-color: #0BB864;
        background-color: #AFF2D8;
      }
      a {
        text-align: left;
        text-decoration: underline;
      }
    }
  }
  
  .color-blue-translation {
    color: #4632FF;
  }
</style>

<style lang="scss">
.quiz .content .questions .answer .answer-text span i {
  color: #4632FF;
}

.quiz .content .questions .question span i {
  color: #4632FF;
}
</style>